import { defineComponent, openBlock, createBlock, unref, withCtx, createVNode, createElementVNode, createElementBlock, Fragment, renderList, normalizeClass, createTextVNode, toDisplayString } from "vue";
import { useDatePickerContext, DatePickerView, DatePickerTableCell, DatePickerTableCellTrigger } from "@ark-ui/vue/date-picker";
import Header from "./Header.vue.js";
const _hoisted_1 = { class: "elfie-datepicker__table" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "MonthView",
  setup(__props) {
    const datePicker = useDatePickerContext();
    const isMonthDisabled = (monthValue, datePicker2) => {
      try {
        const state = datePicker2.getMonthTableCellState({ value: monthValue });
        return state.disabled || !state.selectable;
      } catch {
        return false;
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(DatePickerView), { view: "month" }, {
        default: withCtx(() => [
          createVNode(Header),
          createElementVNode("table", _hoisted_1, [
            createElementVNode("tbody", null, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(unref(datePicker).getMonthsGrid({
                columns: 4,
                format: "short"
              }), (months, rowId) => {
                return openBlock(), createElementBlock("tr", { key: rowId }, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(months, (month, monthId) => {
                    return openBlock(), createElementBlock("td", {
                      key: monthId,
                      class: "elfie-datepicker__table-cell"
                    }, [
                      createVNode(unref(DatePickerTableCell), {
                        value: month.value
                      }, {
                        default: withCtx(() => [
                          createVNode(unref(DatePickerTableCellTrigger), {
                            class: normalizeClass([
                              "elfie-datepicker__month-cell",
                              {
                                "elfie-datepicker__month-cell--disabled": isMonthDisabled(month.value, unref(datePicker))
                              }
                            ])
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString(month.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["class"])
                        ]),
                        _: 2
                      }, 1032, ["value"])
                    ]);
                  }), 128))
                ]);
              }), 128))
            ])
          ])
        ]),
        _: 1
      });
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=MonthView.vue2.js.map
